module.exports = __webpack_public_path__ + "05.svg?b5d1d8f0919384629c9ada8fe4e0534c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_setting/05.svg
// module id = 64
// module chunks = 0